module.exports = __webpack_public_path__ + "img/wagon_driving.192d382d.svg";